import { type LucideIcon } from 'lucide-react';
import { type ReactNode } from 'react';

interface SearchItemLayoutProps {
  icon: LucideIcon;
  primary: string;
  secondary?: ReactNode;
  tertiary?: ReactNode;
  quaternary?: ReactNode;
}

export function SearchItemLayout({
  icon: Icon,
  primary,
  secondary,
  tertiary,
  quaternary,
}: SearchItemLayoutProps) {
  const hasSecondaryRow = !!tertiary || !!quaternary;

  return (
    <>
      <div className="flex w-full items-center gap-2">
        <Icon className="h-4 w-4 text-muted-foreground" />
        <span>{primary}</span>
        {secondary}
      </div>
      {hasSecondaryRow && (
        <div className="flex w-full items-center justify-between gap-2 pl-6 pr-6 text-sm text-muted-foreground">
          <div>{tertiary}</div>
          <div>{quaternary}</div>
        </div>
      )}
    </>
  );
}
